import { useMutation } from '@tanstack/react-query';

import { PluginSendBrokerQuoteApprovalEmailRequest } from '../../../../types/plugins';
import { handleError, handleSuccess } from '../../../../utils/admin';
import { useRequestConstructor } from '../../../hooks/useRequestConstructor';
import { getApiErrorMessage } from '../../../logic';
import { ApiErrorResponse } from '../../../types';
import { runSendBrokerQuoteApprovalEmail } from '../../requests/runSendBrokerQuoteApprovalEmail';

export const useRunSendBrokerQuoteApprovalEmail = () => {
  const { constructPost } = useRequestConstructor();
  const { mutateAsync, ...rest } = useMutation({
    mutationFn: (data: PluginSendBrokerQuoteApprovalEmailRequest) =>
      runSendBrokerQuoteApprovalEmail(constructPost, data),
    onSuccess: () => handleSuccess('Email has been sent to broker.'),
    onError: (error: ApiErrorResponse) =>
      handleError(getApiErrorMessage(error, 'Failed to send approval email.')),
  });
  return { runSendBrokerQuoteApprovalEmail: mutateAsync, ...rest };
};
